import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';

const inlineStyles = () => ({
  priceLabel: {
    fontWeight: 'bold',
    fontSize: 16,
    lineHeight: 1,
    paddingBottom: 6,
  },
  pricePrimary: {
    fontWeight: 'bold',
  },
  priceSecondary: {
    fontSize: 14,
  },
});

/**
 *
 * @param {*} param0
 * @returns
 */

const Price = ({ t, classes, prices, template }) => {
  const { priceLabel, primaryPrice, secondaryPrice } = prices;

  if (template === 'compact') {
    return (
      <>
        {priceLabel && `${priceLabel}: `} {primaryPrice}{' '}
        {secondaryPrice && `(${t('views.landing.priceNormally')} ${secondaryPrice})`}
      </>
    );
  }
  return (
    <div className={classes.priceContainer}>
      {priceLabel && (
        <Typography
          variant="body1"
          color={secondaryPrice ? 'primary' : 'initial'}
          className={classes.priceLabel}
          display="inline">
          {priceLabel}&nbsp;
        </Typography>
      )}

      <Typography
        variant="body1"
        color={secondaryPrice ? 'primary' : 'initial'}
        className={classes.pricePrimary}
        display="inline">
        {primaryPrice}
      </Typography>

      {secondaryPrice && (
        <Typography variant="body1" className={classes.priceSecondary} display="inline">
          &nbsp; ({t('views.landing.priceNormally')} {secondaryPrice})
        </Typography>
      )}
    </div>
  );
};

Price.propTypes = {
  classes: PropTypes.object,
  prices: PropTypes.object,
  t: PropTypes.func,
  template: PropTypes.string,
};

Price.defaultProps = {
  classes: {},
  prices: {},
  t: null,
  template: '',
};

export default withStyles(inlineStyles)(withTranslation('translations')(Price));
